// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.validation-error {
  background-color: #ffc8c8;
}

.validation-warning {
  background-color: #fff8a0;
}

.validation-notice {
  background-color: green;
}

.validation-text {
  color: red;
  font-size: 18px;
  font-weight: bold;
  padding: 15px;
}

.validation-icon-circle {
  padding: 15px 15px 1px 15px;
}

.validation-icon-text {
  color: red;
  font-size: 18px;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/base/block-control/block-control.component.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,UAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;AACJ;;AAEA;EACI,2BAAA;AACJ;;AAEA;EACI,UAAA;EACA,eAAA;EACA,iBAAA;AACJ","sourcesContent":[".validation-error {\n    background-color: #ffc8c8;\n}\n\n.validation-warning {\n    background-color: #fff8a0;\n}\n\n.validation-notice {\n    background-color: green;\n}\n\n.validation-text {\n    color: red;\n    font-size: 18px;\n    font-weight: bold;\n    padding: 15px;\n}\n\n.validation-icon-circle {\n    padding: 15px 15px 1px 15px;\n}\n\n.validation-icon-text {\n    color: red;\n    font-size: 18px;\n    font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
